export const dateGroups = {
  past: {
    key: 'past',
    label: 'Past'
  },
  today: {
    key: 'today',
    label: 'Today'
  },
  thisWeek: {
    key: 'thisWeek',
    label: 'This week'
  },
  future: {
    key: 'future',
    label: 'Future'
  }
};
